import { NgModule } from '@angular/core';

import { LayoutComponent } from './layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { SubHeaderComponent } from './subheader/subheader.component';
import { NavsearchComponent } from './header/navsearch/navsearch.component';
import { OffsidebarComponent } from './offsidebar/offsidebar.component';
import { UserblockComponent } from './sidebar/userblock/userblock.component';
import { UserblockService } from './sidebar/userblock/userblock.service';
import { FooterComponent } from './footer/footer.component';
import { RightsidebarComponent } from './rightsidebar/rightsidebar.component';

import { SharedModule } from '../shared/shared.module';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';

@NgModule({
    imports: [
        SharedModule
    ],
    providers: [
        UserblockService,
        BsDropdownDirective
    ],
    declarations: [
        LayoutComponent,
        SidebarComponent,
        UserblockComponent,
        HeaderComponent,
        SubHeaderComponent,
        NavsearchComponent,
        OffsidebarComponent,
        FooterComponent,
        RightsidebarComponent
    ],
    exports: [
        LayoutComponent,
        SidebarComponent,
        UserblockComponent,
        HeaderComponent,
        SubHeaderComponent,
        NavsearchComponent,
        OffsidebarComponent,
        FooterComponent,
        RightsidebarComponent
    ]
})
export class LayoutModule { }
